<script setup>
import CampaignPlanCard from './CampaignPlanCard.vue';

defineProps({
  campaignPlans: {
    type: Array,
    required: true,
  },
});

const emit = defineEmits(['delete']);

const handleDelete = plan => {
  emit('delete', plan);
};
</script>

<template>
  <div class="flex flex-col gap-4">
    <CampaignPlanCard
      v-for="plan in campaignPlans"
      :key="plan.id"
      :plan="plan"
      @delete="handleDelete(plan)"
    />
  </div>
</template>

